
import { Button, Form, FormElement, Note, StatusBlock, Textarea } from '05-ui-kit';
import { computed, onMounted, ref, shallowRef } from '@vue/composition-api';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import scrollIntoView from 'smooth-scroll-into-view-if-needed';
import type { ValidationResult, VeeObserver } from 'vee-validate/dist/types/types';
import { formatPrice } from '@artmizu/utils';
import { useRouter } from '@nuxtjs/composition-api';
import type { Review } from '~/type/Review';
import PhotoUpload from '~/components/PhotoUpload/PhotoUpload.vue';
import TSProductRating from '~/components/ts-components/TSProductRating/TSProductRating.vue';
import MiniCard from '~/components/MiniCard/MiniCard.vue';
import Timer from '~/components/Timer/Timer.vue';
import type { ProductExtended } from '~/type/product/Product';
interface ObserverRef {
  validateWithInfo: () => Promise<ValidationResult & {
    isValid: boolean;
  }>;
}
const __sfc_main = {};
__sfc_main.props = {
  product: {
    key: "product",
    required: true,
    type: null
  },
  productPrice: {
    key: "productPrice",
    required: true,
    type: Number
  },
  reviewResponse: {
    key: "reviewResponse",
    required: false,
    type: Object
  },
  review: {
    key: "review",
    required: false,
    type: null
  },
  loadError: {
    key: "loadError",
    required: false,
    type: Boolean,
    default: false
  },
  error: {
    key: "error",
    required: false,
    type: Boolean,
    default: false
  },
  success: {
    key: "success",
    required: false,
    type: Boolean,
    default: false
  },
  loading: {
    key: "loading",
    required: false,
    type: Boolean,
    default: false
  },
  type: {
    key: "type",
    required: false,
    type: String,
    default: 'create'
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emit = __ctx.emit;
  const router = useRouter();
  const observerRef = shallowRef();
  const root = shallowRef<HTMLDivElement>();
  onMounted(() => {
    scrollIntoView(root.value!, {
      block: 'start'
    });
  });
  const data = ref<Review>({
    comment: props.review?.comment ?? [],
    image: props.review?.image ?? [],
    text: props.review?.text ?? '',
    productId: props.review?.productId ?? 0,
    id: props.review?.id ?? '',
    rate: props.review?.rate ?? undefined,
    advantage: props.review?.advantage ?? '',
    limitation: props.review?.limitation ?? ''
  });
  const errorImageInput = ref<string>();
  const beautifyPrice = computed(() => props.productPrice ? `${formatPrice(props.productPrice)}₽` : '');
  function onSubmit() {
    const validationObserver: ObserverRef = observerRef.value;
    validationObserver.validateWithInfo().then(({
      errors,
      isValid
    }) => {
      isValid ? emit('send', data.value) : scrollToInvalidEl(errors);
    });
  }
  function scrollToInvalidEl(errors: string[]) {
    const err = Object.entries(errors).map(([key, value]: [key: string, value: string]) => ({
      key,
      value
    })).filter(error => error.value.length);
    const observer: VeeObserver = observerRef.value;
    scrollIntoView(observer.refs[err[0].key].$el, {
      behavior: 'smooth',
      block: 'start'
    });
  }
  function reload() {
    location?.reload();
  }
  return {
    router,
    observerRef,
    root,
    data,
    errorImageInput,
    beautifyPrice,
    onSubmit,
    reload
  };
};
__sfc_main.components = Object.assign({
  StatusBlock,
  Button,
  Timer,
  MiniCard,
  ValidationObserver,
  Form,
  ValidationProvider,
  FormElement,
  TSProductRating,
  Textarea,
  PhotoUpload,
  Note
}, __sfc_main.components);
export default __sfc_main;
